'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = MediaGallery;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _masonryLayout = require('masonry-layout');

var _masonryLayout2 = _interopRequireDefault(_masonryLayout);

function MediaGallery() {

	_pubsub2['default'].on('loader:hide', function () {
		var elem = document.querySelector('.media_list');
		var msnry = new _masonryLayout2['default'](elem, {
			// options
			itemSelector: '.media_list_item',
			percentPosition: true,
			horizontalOrder: true,
			gutter: 20
		});
	});

	var _galleryItems = document.querySelectorAll('.media_list_item'),
	    mediasCollection = [],
	    counter = 0;
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = _galleryItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _item = _step.value;

			var media = {};
			media.type = _item.getAttribute('data-type');
			media.data = _item.getAttribute('data-media');
			mediasCollection.push(media);
			_item.index = counter;
			_item.addEventListener('click', clickItem);
			counter++;
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator['return']) {
				_iterator['return']();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	function clickItem(e) {
		e.preventDefault();
		console.log(this.index);
		var _item = this,
		    index = this.index,
		    data = _item.getAttribute('data-media'),
		    type = _item.getAttribute('data-type');
		//pubsub.emit('lightbox:loadContent', data, type);
		_pubsub2['default'].emit('lightbox:loadContent', index, mediasCollection);
	}
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdG91cmhla2xhLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvcGFydGlhbHMvbWVkaWEtZ2FsbGVyeS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztxQkFLd0IsWUFBWTs7OztvQkFMbkIsTUFBTTs7OztzQkFDSixRQUFROzs7OzZCQUNQLGdCQUFnQjs7OztBQUdyQixTQUFTLFlBQVksR0FBRzs7QUFFdEMscUJBQU8sRUFBRSxDQUFDLGFBQWEsRUFBRSxZQUFVO0FBQ2xDLE1BQUksSUFBSSxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsYUFBYSxDQUFDLENBQUM7QUFDakQsTUFBSSxLQUFLLEdBQUcsK0JBQWEsSUFBSSxFQUFFOztBQUU3QixlQUFZLEVBQUUsa0JBQWtCO0FBQ2hDLGtCQUFlLEVBQUUsSUFBSTtBQUNyQixrQkFBZSxFQUFFLElBQUk7QUFDckIsU0FBTSxFQUFFLEVBQUU7R0FDWCxDQUFDLENBQUM7RUFDSCxDQUFDLENBQUM7O0FBSUgsS0FBSSxhQUFhLEdBQUcsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGtCQUFrQixDQUFDO0tBQy9ELGdCQUFnQixHQUFHLEVBQUU7S0FDcEIsT0FBTyxHQUFHLENBQUMsQ0FBQTs7Ozs7O0FBQ2QsdUJBQW1CLGFBQWEsOEhBQUM7T0FBdkIsS0FBSzs7QUFDZCxPQUFJLEtBQUssR0FBRyxFQUFFLENBQ2I7QUFDRCxRQUFLLENBQUMsSUFBSSxHQUFHLEtBQUssQ0FBQyxZQUFZLENBQUMsV0FBVyxDQUFDLENBQUM7QUFDN0MsUUFBSyxDQUFDLElBQUksR0FBRyxLQUFLLENBQUMsWUFBWSxDQUFDLFlBQVksQ0FBQyxDQUFDO0FBQzlDLG1CQUFnQixDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUM3QixRQUFLLENBQUMsS0FBSyxHQUFHLE9BQU8sQ0FBQztBQUN0QixRQUFLLENBQUMsZ0JBQWdCLENBQUMsT0FBTyxFQUFFLFNBQVMsQ0FBQyxDQUFDO0FBQzNDLFVBQU8sRUFBRyxDQUFDO0dBQ1g7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFRCxVQUFTLFNBQVMsQ0FBQyxDQUFDLEVBQUM7QUFDcEIsR0FBQyxDQUFDLGNBQWMsRUFBRSxDQUFDO0FBQ25CLFNBQU8sQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ3hCLE1BQUksS0FBSyxHQUFHLElBQUk7TUFDZCxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUs7TUFDbEIsSUFBSSxHQUFHLEtBQUssQ0FBQyxZQUFZLENBQUMsWUFBWSxDQUFDO01BQ3ZDLElBQUksR0FBRyxLQUFLLENBQUMsWUFBWSxDQUFDLFdBQVcsQ0FBQyxDQUN2Qzs7QUFFRCxzQkFBTyxJQUFJLENBQUMsc0JBQXNCLEVBQUUsS0FBSyxFQUFFLGdCQUFnQixDQUFDLENBQUM7RUFFN0Q7Q0FDRCIsImZpbGUiOiIvVXNlcnMvYmFiZS9Xb3JrL3RvdXJoZWtsYS51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3BhcnRpYWxzL21lZGlhLWdhbGxlcnkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZ3NhcCBmcm9tICdnc2FwJztcbmltcG9ydCBwdWJzdWIgZnJvbSAncHVic3ViJztcbmltcG9ydCBNYXNvbnJ5IGZyb20gJ21hc29ucnktbGF5b3V0JztcblxuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBNZWRpYUdhbGxlcnkoKSB7XG5cblx0cHVic3ViLm9uKCdsb2FkZXI6aGlkZScsIGZ1bmN0aW9uKCl7XG5cdFx0dmFyIGVsZW0gPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcubWVkaWFfbGlzdCcpO1xuXHRcdHZhciBtc25yeSA9IG5ldyBNYXNvbnJ5KCBlbGVtLCB7XG5cdFx0ICAvLyBvcHRpb25zXG5cdFx0ICBpdGVtU2VsZWN0b3I6ICcubWVkaWFfbGlzdF9pdGVtJywgXG5cdFx0ICBwZXJjZW50UG9zaXRpb246IHRydWUsXG5cdFx0ICBob3Jpem9udGFsT3JkZXI6IHRydWUsXG5cdFx0ICBndXR0ZXI6IDIwXG5cdFx0fSk7XG5cdH0pO1xuXHRcblxuXG5cdGxldCBfZ2FsbGVyeUl0ZW1zID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvckFsbCgnLm1lZGlhX2xpc3RfaXRlbScpXG5cdCxcdG1lZGlhc0NvbGxlY3Rpb24gPSBbXVxuXHQsXHQgY291bnRlciA9IDBcblx0Zm9yKGNvbnN0IF9pdGVtIG9mIF9nYWxsZXJ5SXRlbXMpe1xuXHRcdGxldCBtZWRpYSA9IHt9XG5cdFx0O1xuXHRcdG1lZGlhLnR5cGUgPSBfaXRlbS5nZXRBdHRyaWJ1dGUoJ2RhdGEtdHlwZScpO1xuXHRcdG1lZGlhLmRhdGEgPSBfaXRlbS5nZXRBdHRyaWJ1dGUoJ2RhdGEtbWVkaWEnKTtcblx0XHRtZWRpYXNDb2xsZWN0aW9uLnB1c2gobWVkaWEpO1xuXHRcdF9pdGVtLmluZGV4ID0gY291bnRlcjtcblx0XHRfaXRlbS5hZGRFdmVudExpc3RlbmVyKCdjbGljaycsIGNsaWNrSXRlbSk7XG5cdFx0Y291bnRlciArKztcblx0fVxuXG5cdGZ1bmN0aW9uIGNsaWNrSXRlbShlKXtcblx0XHRlLnByZXZlbnREZWZhdWx0KCk7XG5cdFx0Y29uc29sZS5sb2codGhpcy5pbmRleCk7XG5cdFx0dmFyIF9pdGVtID0gdGhpc1xuXHRcdCxcdGluZGV4ID0gdGhpcy5pbmRleFxuXHRcdCxcdGRhdGEgPSBfaXRlbS5nZXRBdHRyaWJ1dGUoJ2RhdGEtbWVkaWEnKVxuXHRcdCxcdHR5cGUgPSBfaXRlbS5nZXRBdHRyaWJ1dGUoJ2RhdGEtdHlwZScpXG5cdFx0O1xuXHRcdC8vcHVic3ViLmVtaXQoJ2xpZ2h0Ym94OmxvYWRDb250ZW50JywgZGF0YSwgdHlwZSk7XG5cdFx0cHVic3ViLmVtaXQoJ2xpZ2h0Ym94OmxvYWRDb250ZW50JywgaW5kZXgsIG1lZGlhc0NvbGxlY3Rpb24pO1xuXHRcdFxuXHR9XG59XG4iXX0=